export const MONTHS = {
  january: 'Jan',
  february: 'Feb',
  march: 'Mar',
  april: 'Apr',
  may: 'May',
  june: 'Jun',
  july: 'Jul',
  august: 'Aug',
  september: 'Sep',
  october: 'Oct',
  november: 'Nov',
  december: 'Dec',
};
export const SERVICE_OPTIONS_LIST = [
  { value: 'All', label: 'All' },
  { value: 'Assurance', label: 'Assurance (excl. ACR)' },
  { value: 'Consulting', label: 'Consulting' },
  { value: 'SAT', label: 'SAT (excl. ITTS)' },
  { value: 'TAX', label: 'TAX (excl. ITTS)' },
  { value: 'ITTS', label: 'ITTS' },
  { value: 'EMIA_ACR', label: 'EMEIA ACR' },
];

export const QUARTER_OPTIONS_LIST = [
  { value: 'Q1', label: 'Q1', id: 1 },
  { value: 'Q2', label: 'Q2', id: 2 },
  { value: 'Q3', label: 'Q3', id: 3 },
  { value: 'Q4', label: 'Q4', id: 4 },
];

export const ABBREVIATED_MONTH_LIST = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const YEARLY_QUARTER = {
  q1: 'Q1',
  q2: 'Q2',
  q3: 'Q3',
  q4: 'Q4',
};

export const MONTHLY_QUARTERR = {
  q1: [MONTHS.july, MONTHS.august, MONTHS.september],
  q2: [MONTHS.october, MONTHS.november, MONTHS.december],
  q3: [MONTHS.january, MONTHS.february, MONTHS.march],
  q4: [MONTHS.april, MONTHS.may, MONTHS.june],
};

export const MONTHLY_QUARTER = {
  q1: ['july', 'august', 'september'],
  q2: ['october', 'november', 'december'],
  q3: ['january', 'february', 'march'],
  q4: ['april', 'may', 'june'],
};

// SUB_HEADER - Sub Headers Constant
export const SUB_HEADER = {
  DUE_TODAY: 'Due Today',
  DUE_IN: 'Due in',
  DAY: 'Day',
  DAYS: 'Days',
};

// ECM - Exit Confirmation Modal AT PL Screen
export const ECM = {
  HEADER_TITLE: 'Your Changes Are Not Submitted',
  DESCRIPTON:
    'Your forecast has changes that were not submitted. If you exit the page without submitting, all changes will be saved but your forecast will not be submitted.',
  EXIT_BUTTON_TITLE: 'Exit Without Submitting',
};

export const SUBMITSUCCESSFUL = {
  HEADER_TITLE: 'Forecast Submitted',
  DESCRIPTON1: 'Your forecast for',
  DESCRIPTON2: 'was successfully submitted',
  VIEW_DASBOARD: 'View Dashboard',
  AND: 'and',
  FOR: 'for',
  PROJECTION: 'projection for the next two months ',
};

export const FAILEDTRANSACTION = {
  HEADER_TITLE: 'Error',
  MESSAGE_LINE1: 'Unexpected error has occured.',
  MESSAGE_LINE2: 'Please try again or reach out to the support',
};

export const BUTTON_TITLE = {
  CANCEL: 'Cancel',
  SUBMIT: 'Submit',
  VIEW: 'View',
  FORECAST: 'Forecast',
  CLOSE: 'Close',
  CLOSE_AND_REFRESH: 'Close & Refresh',

  OPEN_EY_CRM: 'Open EY CRM',
  RESET: 'Reset',
  ENTER_ANOTHER_EMAIL_ID: 'Enter another Email Id',
};

export const WARNING_MESSAGES = {
  do_not_show_again: 'Do not show this message again',
};

export const DATA_CARD_ONE = {
  FORECAST_ACCURACY: 'FORECAST ACCURACY',
  QUARTERLY: 'Quarterly',
  MONTHLY: 'Monthly',
  LABLE: 'Sold vs Submitted | Till Date FY',
};

export const DATA_CARD_TWO = {
  FORECAST_COMPLETION: 'FORECAST COMPLETION',
  SUBMITTED: 'Submitted',
  MISSED: 'Missed',
  REMAINING: 'Remaining',
};

export const DATA_CARD_THREE = {
  TITLE: '% OF OPPS: OPEN TO CLOSE DURATION',
  LABLE_ONE: 'Within 7 days or less',
  LABLE_TWO: 'Within 30 days or less',
  LABLE_THREE: 'Within 90 days or less',
};

export const QUARTERLY_DETAILS = {
  TITLE: 'FORECAST ACCURACY - QUARTER',
  FORECAST_SUMMARY: 'FORECAST SUMMARY - QUARTER',
  COMMIT: 'Commit',
  NO_COMMIT: 'No Commit',
  MONTHLY_DETAILS: 'MONTHLY DETAILS',
  WON: 'Won',
  LOST: 'Lost',
  OPEN: 'Open',
  DECLINED: 'Declined',
  COMMITTED: 'Committed',
  NOT_COMMITTED: 'Not Committed',
  MISSED: 'Missed',
  FORECAST: 'Forecast',
  SUBMITTED_FORECAST: 'Submitted Forecast',
  SUB: 'Sub...',
  FORECASTED: 'Forecasted',
  PROJECTED: 'Projected',
  TBD: 'TBD',
  ACCURACY: 'Accuracy',
  GAP: 'Gap',
  COMMIT_OPPS: 'Commit Opps',
  PROJECTED_OPPS: 'Projected Opps',
  WON_OPPS: 'Won Opps.',
  NOT_APPLICABLE: 'NA',
  MONTHLY_BREAKDOWN: 'MONTHLY BREAKDOWN',
  PL_COMMITED_OPPS: 'PL Committed Opps.',
  PL_PROJECTED_OPPS: 'PL Projected Opps.',
  PL_FORECAST_GCSP: 'PL Forecast + Audit/TR',
  PL_FORECAST_MSL: 'PL Forecast + Audit/TR',
  YOUR_JUDGE: 'Your Judge',
  YOUR_PROJECTED: 'Your Projected',
  YOUR_COMMIT: 'Your Commit',
  GCSP_JUDGE: 'GCSP Judge',
  VARIANCE: 'Variance',
  UNCOMMITED_PIPELINE: 'Uncommitted Pipeline',
  PROJECTED_FORECAST: 'Projected Forecast',
  TOTAL_FORECAST: 'Total Forecast',
  PL_PROJECTED_FORECAST_GCSP: 'PL Projected Forecast + Audit/TR',
  PL_PROJECTED_FORECAST_MSL: 'PL Projected Forecast + Audit/TR',
  TOTAL_PROJECTED_FORECAST: 'Total Projected Forecast',
  CURRENT_COMMIT: 'Current Commit',
};

export const DATA_MISMATCH_ERROR = {
  title: 'Data Mismatch',
  message:
    'There has been a change or update in the data for the selected oppotunties. Please refresh and review the data again.',
  buttonText: 'Close & Refresh',
};

export const SAM = {
  title: 'Submit Acknowledgment',
  message: 'By clicking the submit button you acknowledge that you have:',
  bulletPoint1: 'Verified the judge values are accurate',
  bulletPoint2: 'Confirm the "Your Commit Value" for the next fiscal month',
};

export const PRIVACY_STATEMENT = {
  HEADER_TITLE: 'Privacy Notice',
  DESCRIPTION1: `
    EY does not intentionally collect any sensitive personal data from you via the Tool. The Tool’s intention is not to process such information.`,
  DESCRIPTION2: `
      Accordingly, you should not enter any unnecessary personal information or any sensitive personal data (including government identifiers such as tax file numbers or social security numbers/national identification numbers), client confidential information (except client entity names), audit secrets, state secrets, trade secrets, or anything that would violate professional secrecy or confidentiality rules or that would be considered abusive/irrelevant in the Tool.`,
  DESCRIPTION3: `
      Personal and contact data available in the Tool is intended to be used for supporting communications to deliver services and manage sales and should not be used to contact individuals for marketing purposes.
  `,
};

export const IFRAME_EXIT_MODAL_REFRESH = {
  TITLE: 'Opportunity Details',
  GO_BACK: 'Go Back',
  EXIT_REFRESH: 'Exit & Refresh',
  DESCRIPTION1: 'Did You Save Changes?',
  DESCRIPTION2: 'Please make sure you"ve saved your changes before continuing.',
  DESCRIPTION3: 'You must click "Save" in the header of the Opportunity Details screen.',
  DESCRIPTION4:
    'Ok to Exit Opportunity Details, I"ve already saved my changes. This will refresh the Sales Forecasting page.',
};

export const OPPORTUNITY_ACCESS_NOTE = {
  NOTE_TITLE: 'Note:',
  ERROR_MESSAGE: 'If you are facing an error accessing your opportunities, please click on the',
  LINK_TEXT: 'link',
  SIGNIN_MESSAGE: 'to sign in to  Dynamics. Once signed in, please close and refresh the page.',
};

export const FORECAST_SIDEBAR_DATA_CONST = {
  NOW: 'now',
  NEXT: 'next',
  BEYOND: 'beyond',
};

export const FORECAST_SIDEBAR_QUARTER_CONST = {
  NOW: 'NOW',
  NEXT: 'NEXT',
  BEYOND: 'BEYOND',
};

export const LOGOUT_SCREEN = {
  HEADER_TITLE: 'Logged Out Successfully',
  DESCRIPTION: `
  Your session with the Sales Forecasting Application has ended. To restart the application, please utilize the button below.`,
  BUTTON_TITLE: 'Restart Application',
};

export const RESTART_REQUIRED_SCREEN = {
  HEADER_TITLE: 'Application Restart Required',
  DESCRIPTION: `
  There have been changes to your profile that require a restart of the application. Restarting will give you access to the application with your updated profile roles.`,
  BUTTON_TITLE: 'Restart Application',
};

export const ROLE_CONST = {
  PL: 'PL',
  GCSP: 'GCSP',
  GCSP_READ_ONLY: 'GCSP READ ONLY',
  MSL: 'MSL',
  MSL_READ_ONLY: 'MSL READ ONLY',
  MSL_DELEGATE: 'MSL DELEGATE',
};

export const TABLE_HEADER_SUBTEXT = {
  DATE_FISCAL_MONTH: 'Date (Fiscal Month)',
  EXCL_ACR: 'excl. ACR',
  EXCL_ITTS: 'excl. ITTS',
  ACTUAL_FORECASTED: 'Actual vs (Forecasted)',
};

export const MSL_TABLE_HEADER_SUBTEXT = {
  DATE_FISCAL_MONTH: 'Date (Fiscal Month)',
  EXCL_ACR: 'excl. ACR',
  EXCL_ITTS: 'excl. ITTS',
  EXCL_SAT: 'excl. ITTS',
  EXCL_TAX: 'excl. ITTS',
  ACTUAL_FORECASTED: 'Actual vs (Forecasted)',
  WON_FORECASTED: 'Won vs (Forecasted)',
};

export const PAGE = {
  DESKTOP: 'desktop',
  FORECAST: 'forecast',
  PAST_FORECAST: 'past forecast',
};

export const OPERATING_SYSTEM = {
  WINDOWS: 'WINDOWS',
  MAC: 'MAC',
  LINUX: 'LINUX',
  ANDROID: 'ANDROID',
  IOS: 'IOS',
};

//tags
export const MONTH_QUARTER_STATUS = {
  NOT_APPLICABLE: 'not applicable',
  MISSED: 'missed',
  SUBMITTED: 'submitted',
  REMAINING: 'remaining',
};

export const PERIOD = {
  PAST: 'past',
  CURRENT: 'current',
  FUTURE: 'future',
};

export const CHIP = {
  PAST: 'Past',
  CURRENT: 'Current',
  FUTURE: 'Future',
};

export const SOURCE = {
  FRONTEND: 'Frontend',
};

export const LOADING_MODAL_CONST = {
  HEADER_TITLE: 'Processing....',
  DESCRIPTION1:
    'Thank you for your submission. We are currently verifying and validating the details you provided. This will only take a moment.',
};

export const SIDEBAR_WARNING = {
  WARNING_MESSAGE:
    'Please allow time for data synchronization between individual opportunity line items and the summary data below. You can also manually refresh to ensure data synchronization.',
};

export const ROLE_FULL_FORM = {
  PURSUIT_LEADER: 'Pursuit Leader',
  GCSP: 'GCSP', // Global Client Service Partner
  MARKET_SEGMENTS_LEADER: 'Market Segments Leader',
};

export const PAGES_NAME = {
  LIVE_FORECAST: 'Live Forecast',
  PAST_FORECAST: 'Past Forecast',
};

export const ACCESS_DENIED_MODAL = {
  HEADER_TITLE: 'Access Denied!',
  DESCRIPTION:
    'Unfortunately, the Sales Forecasting application is unavailable in your region. We apologize for any inconvenience. Access is limited to specified regions.',
};

export const FORBIDDEN_ACCESS_MODAL = {
  HEADER_TITLE: 'Forbidden Access!',
  DESCRIPTION1: 'Your current role does not have access to the requested service.',
  DESCRIPTION2:
    'Please ensure that you have opportunities assigned to you and that you are assigned the correct role in EY CRM or Mercury to access the Forecasting application.',
};

export const FORECAST_TABLE_CONST = {
  YOUR_JUDGE: 'your_judge',
  PL_GCSP: 'pl_gcsp',
  YOUR_TOTAL_COMMIT: 'your_total_commit',
  GCSP_JUDGE: 'Your Judge',
};

export const MSL_JUDGE_MODAL_CONST = {
  PL_GCSP_COMMIT: 'Total Committed (PL Commits + GCSP Judge)',
};

export const MSL_TOOLTIP_MESSAGES = {
  PURSUIT_LEADER_COMMITS_AUDIT_TR:
    'Audit and Technology Risk opportunities with 100% win probability\nor Renewal pursuit type are automatically included\nin the Sales Forecast.\nPursuit Leaders do not submit forecasts for these\ndue to Independence requirements.',
  TOTAL_FORECASTED_PL_COMMIT_AUDIT_TR_GCSP:
    'Audit and Technology Risk opportunities with 100% win probability\nor Renewal pursuit type are automatically included\nin the Sales Forecast.\nPursuit Leaders do not submit forecasts for these\ndue to Independence requirements.',
};

export const PAGES = {
  DASHBOARD: 'dashboard',
  FORECAST: 'forecast',
};

export const DASHBOARD_PAGE_TITLE = {
  MY_DASHBOARD: 'My Dashboard',
  YEARLY_METRICS: 'Yearly Metrics',
  QUARTERLY_METRICS: 'Quarterly/Monthly Metrics',
};

export const SKELETON_LOADER_CONST = {
  LOADING: 'loading',
};

export const SUBMISSION_FAILURE_MODAL = {
  HEADER_TITLE: 'Error',
  DESCRIPTION:
    'Submission cannot be completed at this time as the submission window is currently closed.',
  BUTTON_TITLE: 'Refresh',
};

export const SESSION_EXPIRE = {
  HEADER_TITLE: 'WARNING',
  DESCRIPTION1:
    'Your session is about to expire due to inactivity. To keep working, select Extend Session.',
  DESCRIPTION2: 'Your session will expire in ',
  BUTTON_TITLE: 'Extend Session',
};

export const SUPER_USER_CONST = {
  TITLE: 'Super User',
  SUBMIT_BUTTON_TITLE: 'Submit',
  CLOSE_BUTTON: 'Close',
  RESET_BUTTON: 'Reset',
  IS_VALID_EMAIL_MESSAGE: 'Please enter a valid email.',
  IS_ACCESS_DENIED_MESSAGE: 'Access Deined for entered Email Id. Please contact your admin.',
  IS_FORBIDDEN_ACCESS_MESSAGE: 'Forbidden Access for entered Email Id. Please contact your admin.',
  IS_PROFILE_API_FAILED_MESSAGE: 'Unable to fetch user details. Please contact your admin.',
  IS_SAME_USER_MESSAGE:
    'You have entered your own super User Email Id. Kindly Click on Reset button.',
  IS_SAME_SESSION_USER_MESSAGE:
    'You have entered your own super User Email Id. Kindly enter another Email Id.',
  IS_SAME_TARGET_USER_MESSAGE:
    'You’re currently using the same user session. Kindly enter another Email Id.',
};

export const NO_USER_FOUND_MODAL = {
  HEADER_TITLE: 'User Not Found',
  DESCRIPTION_1: 'Entered Email-Id ',
  DESCRIPTION_2: ' was not found in EY organization.',
  DESCRIPTION_3: 'Please check the Email-Id / Username and try again.',
  BUTTON_TITLE: 'Enter Another Email-Id',
};

export const SUPER_USER_ACCESS_RESTRICTION = {
  // IS_OPEN: true,
  HEADER_TITLE: 'Access Restricted',
  DESCRIPTION: 'This functionality is currently disabled for the Super User profile',
  CLOSE_BUTTON_TEXT: 'Ok',
};
